import { Box } from '@talos/kyoko';
import styled from 'styled-components';
import { MakeDefaultMarketAccountButton } from '../../DefaultMarketAccount/styles';

export const StyleWrapper = styled(Box)`
  --ag-row-hover-color: ${({ theme }) => theme.backgroundDropdownSelected};
  .ag-pinned-left-cols-container,
  .ag-pinned-left-sticky-top {
    .market-selector-row-selected {
      border-bottom: solid 1px ${({ theme }) => theme.backgroundDivider};
      &:before {
        content: '';
        display: block;
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 3px;
        background-color: var(--colors-primary-lighten);
      }
    }
  }

  .market-selector-row-selected {
    background-color: ${({ theme }) => theme.backgroundDropdownSelected};
    border-bottom: solid 1px ${({ theme }) => theme.backgroundDivider};
  }

  .ag-row {
    ${MakeDefaultMarketAccountButton} {
      display: none;
    }

    &.ag-row-hover {
      background-color: ${({ theme }) => theme.backgroundDropdownSelected};
      ${MakeDefaultMarketAccountButton} {
        display: inline-flex;
      }
    }
  }
`;
